import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";
import config from "../../config";

const Privacy = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    document.title = `Privacy Policy | Agile Seekers`;
    document.getElementById("bodywrap").className = "privacymain";

    // Define your API URL
    const apiUrl = `${config.API_BASE_URL}/page`;

    // Prepare the request payload
    const requestData = {
      page_name: "privacy_policy",
    };

    // Make the POST request
    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 1) {
          setContent(data.data.content); // Set the fetched content
        } else {
          setError("Failed to load content");
          console.error("Error:", data.message);
        }
        setLoading(false); // Hide loading indicator
      })
      .catch((error) => {
        console.error("Fetch Error:", error);
      });
  }, []);

  return (
    <>
      <Navbar />

      <section>
        <Container>
          <Row>
            <Col className="privacy-top">
              <h2>Privacy Policy</h2>
            </Col>
          </Row>
          <Row>
            {loading && <div>Loading...</div>}
            {!loading && error && <div>{error}</div>}
            {!loading && !error && (
              <Col
                className="privacy-content"
                id="pageContent"
                dangerouslySetInnerHTML={{ __html: content }}
              ></Col>
            )}
          </Row>
        </Container>
      </section>

      <Footer />
    </>
  );
};
export default Privacy;
